import { EnvelopeWithStatus } from 'types/Envelope';

export const getEnvelopeSignatureId = (envelope: EnvelopeWithStatus): string =>
  envelope.envelopeStatus?.envelopeInfo?.envelopeId || '';
